import {
    assign
} from 'min-dash';

export default function ExamplePaletteProvider(create, elementFactory,handTool, lassoTool, globalConnect, palette,myOptions) {
    this._create = create;
    this._elementFactory = elementFactory;
    this._handTool = handTool;
    this._lassoTool = lassoTool;
    this._globalConnect = globalConnect;
    this._palette = palette;
    this._myOptions = myOptions;
  
    palette.registerProvider(this);
  }
  
  ExamplePaletteProvider.$inject = [
    'create',
    'elementFactory',
    'handTool',
    'lassoTool',
    'globalConnect',
    'palette',

    'myOptions'

  ];
  
  
  ExamplePaletteProvider.prototype.getPaletteEntries = function() {
    var create = this._create,
        elementFactory = this._elementFactory,
        handTool = this._handTool,
        lassoTool = this._lassoTool,
        globalConnect = this._globalConnect,
        myOptions = this._myOptions;
        
    function createAction(type, group, className, title, options) {

        function createListener(event) {
            var shape = elementFactory.createShape(assign({ type: type }, options));
            create.start(event, shape);
        }
        
        return {
            group: group,
            className: className,
            title: title,
            action: {
                dragstart: createListener,
                click: createListener
            }
        };
    }
    
    console.log(myOptions);
  
    let tools = {
        'hand-tool': {
            group: 'tools',
            className: 'icon-hand-tool',
            title: '激活手动工具',
            action: {
              click: function(event) {
                handTool.activateHand(event);
              }
            }
        },
        'lasso-tool': {
            group: 'tools',
            className: 'icon-lasso-tool',
            title: '激活套索工具',
            action: {
                click: function(event) {
                    lassoTool.activateSelection(event);
                }
            }
        },
        'global-connect-tool': {
            group: 'tools',
            className: 'icon-line-tool',
            title: '激活连线工具',
            action: {
              click: function(event) {
                globalConnect.toggle(event);
              }
            }
        },
        'tool-separator': {
            group: 'tools',
            separator: true
        }
    };
    for(let key in myOptions.palette){
        var item = myOptions.palette[key];
        tools[key] = createAction(item.type, item.group, item.className, item.title, item.options);
    }
    
    //console.log(tools,'tools');
    return tools;
    
  };